export const SupportedDataFormats = () => (
  <>
    <h3>Supported dataformats</h3>
    Irrespecitive of the data format chosen, the lipid data will internally be normalized to profiles.
    <h4>mzTab-M</h4>
    <p>
      mzTab-M is a data standard intended for sharing quantitative lipidomics and metabolomics mass spectrometry data 
      and the prefered data format for submitting lipid profiles for optimizations.
    </p>
    <h5>Requirements</h5>
    <p>
      <ul>
        <li>Only metadata and summary tables are required</li>
        <li>The <strong>chemical_name</strong> column is used as <a>Lipid Column</a></li>
      </ul>
    </p>
    <h5>Advantages</h5>
    <p>
      <ul>
        <li>Defined metadata, e.g. study variables and samples, is respected and used to generate a meaningful report</li>
        <li>Standardized data format</li>
        <li><a href="https://apps.lifs-tools.org/mztabvalidator/">Online data validator</a> available</li>
      </ul>
    </p>
    <h4>Other supported tabular dataformats</h4>
    <p>
      Fatty Acylizer supports common tabular formats such CSV, Microsoft Excel, and LibreOffice Calc.
      The first column of the table is treated as the <a>lipid column</a>, 
      while the remaining columns contain the lipid profiles for fitting.
    </p>
  </>
)
